import BootstrapTable from './src/bootstrap-table';
import withContext from './src/contexts';

export default withContext(BootstrapTable);



// WEBPACK FOOTER //
// ./packages/react-bootstrap-table2/index.js